import { render, staticRenderFns } from "./MiniRelativeDate.vue?vue&type=template&id=3564f42d&scoped=true&"
import script from "./MiniRelativeDate.vue?vue&type=script&lang=js&"
export * from "./MiniRelativeDate.vue?vue&type=script&lang=js&"
import style0 from "./MiniRelativeDate.vue?vue&type=style&index=0&id=3564f42d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3564f42d",
  null
  
)

export default component.exports